import Model, { attr } from '@ember-data/model';

export default class UploadedFileDatum extends Model {
  @attr('string') fileName;
  @attr('string') fileUrl;

  @attr('Date') expiresAt;

  get isExpired() {
    return this.expiresAt <= new Date();
  }
}
